<template>
  <div id="school" class="layer home">
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 722.3 676.6">
  <path class="cls-25" d="M354.2,287.3c-1,0-2,.2-2.8.5-1.1-2.2-3.3-3.8-5.9-3.9s-4.3,1-5.6,2.6c-.9-.5-1.9-.8-3-.8-3.2,0-5.9,2-6.7,4.8-.7-.3-1.6-.5-2.4-.5-3.8-.1-6.9,2.8-7,6.6,0,.9.1,1.7.4,2.5-2,1.1-3.3,3.2-3.4,5.7s2.1,6,5.1,6.8c.2,3.5,3,6.3,6.6,6.4,8.2.3,15.8-.4,24-.2s6.9-2.8,7-6.6c0-.8,0-1.6-.3-2.3,2.7-.8,4.7-3.3,4.8-6.3s-1.7-5.5-4.3-6.5c.2-.6.3-1.2.3-1.8.1-3.8-2.8-6.9-6.6-7h-.2Z"/>
  <path class="cls-25" d="M489.8,288.1c-1,0-2,.2-2.8.5-1.1-2.2-3.3-3.8-5.9-3.9s-4.3,1-5.6,2.6c-.9-.5-1.9-.8-3-.8-3.2,0-5.9,2-6.7,4.8-.7-.3-1.6-.5-2.4-.5-3.8-.1-6.9,2.8-7,6.6,0,.9.1,1.7.4,2.5-2,1.1-3.3,3.2-3.4,5.7,0,3.3,2.1,6,5.1,6.8.2,3.5,3,6.3,6.6,6.4,8.2.3,15.8-.4,24-.2s6.9-2.8,7-6.6c0-.8,0-1.6-.3-2.3,2.7-.8,4.7-3.3,4.8-6.3s-1.7-5.5-4.3-6.5c.2-.6.3-1.2.3-1.8.1-3.8-2.8-6.9-6.6-7h-.2Z"/>
  <path class="cls-25" d="M460,299.4c-.9,0-1.7.2-2.5.5-1-1.9-3-3.2-5.3-3.2s-3.7,1-4.8,2.4c-.8-.4-1.7-.6-2.6-.6-2.7,0-5.1,1.9-5.7,4.4-.7-.2-1.4-.4-2.1-.4-3.3,0-5.9,2.7-5.9,5.9s.1,1.5.4,2.2c-1.7,1-2.8,2.9-2.8,5s2,5.2,4.6,5.8c.3,3,2.8,5.4,5.9,5.4,7.2,0,13.7-.8,20.9-.8s5.9-2.7,5.9-5.9-.1-1.4-.4-2c2.3-.8,4-3,4-5.6s-1.6-4.8-3.9-5.6c.1-.5.2-1,.2-1.6,0-3.3-2.7-5.9-5.9-5.9h0Z"/>
  <path v-if="highlight || found || manualHighlight" v-bind:class="{ active: found }" class="cls-19" d="M483.5,251.6h-53.2l-9.4-9.4h15l-9.7-8.1,9.7-8.1h-24.5c-3.3,0-6,2.7-6,6v6.7l-12.9,12.9h-53.2l-10.2,23.8h7.5v47.6h50c0,.1,99.6.1,99.6.1h0c0-.1,0-.1,0-.1v-47.6h7.5l-10.3-23.8Z"/>
  <g>
    <g class="homeHotSpot" @click="clickHome" @mouseover="showHighlight" @mouseleave="hideHighlight">
      <rect class="cls-8" x="431.3" y="270.4" width="50" height="47.6"/>
      <polygon class="cls-36" points="436.4 270.4 431.3 270.4 431.3 318.1 481.2 318.1 481.2 315.3 436.4 270.4"/>
      <g>
        <rect class="cls-50" x="438.7" y="276.7" width="14.9" height="15.2"/>
        <path class="cls-22" d="M438.7,283c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <polygon class="cls-32" points="438.7 276.7 442.7 276.7 453.6 287.6 453.6 291.9 438.7 291.9 438.7 276.7"/>
        <path class="cls-36" d="M438.7,283c-.5,0-1-.4-1-1s.4-1,1-1h8.3l3,3v7.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-50" x="460" y="276.7" width="14.9" height="15.2"/>
        <path class="cls-22" d="M460,283c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-52" x="438.7" y="296.9" width="14.9" height="15.2"/>
        <path class="cls-36" d="M438.7,303.2c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-50" x="460" y="296.9" width="14.9" height="15.2"/>
        <path class="cls-22" d="M460,303.2c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <polygon class="cls-32" points="460 296.9 462.9 296.9 474.9 309 474.9 312.2 460 312.2 460 296.9"/>
        <path class="cls-36" d="M460,303.2c-.5,0-1-.4-1-1s.4-1,1-1h7.2l2,2h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6ZM471.3,305.3v6.8c0,.5-.4,1-1,1s-1-.4-1-1v-8.8l2,2Z"/>
      </g>
      <rect class="cls-8" x="341.6" y="270.4" width="50" height="47.6"/>
      <g>
        <rect class="cls-50" x="347.9" y="276.7" width="14.9" height="15.2"/>
        <path class="cls-22" d="M347.9,283c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-50" x="369.2" y="276.7" width="14.9" height="15.2"/>
        <path class="cls-22" d="M369.2,283c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-50" x="347.9" y="296.9" width="14.9" height="15.2"/>
        <path class="cls-22" d="M347.9,303.2c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <g>
        <rect class="cls-50" x="369.2" y="296.9" width="14.9" height="15.2"/>
        <path class="cls-22" d="M369.2,303.2c-.5,0-1-.4-1-1s.4-1,1-1h14.9c.5,0,1,.4,1,1s-.4,1-1,1h-3.6v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.7v8.9c0,.5-.4,1-1,1s-1-.4-1-1v-8.9h-3.6,0Z"/>
      </g>
      <polygon class="cls-7" points="431.3 270.4 486.2 270.4 480.2 256.6 425.3 256.6 431.3 262.5 431.3 270.4"/>
      <polygon class="cls-22" points="411.4 242.9 391.6 262.5 391.6 318.1 431.3 318.1 431.3 262.5 411.4 242.9"/>
      <rect class="cls-41" x="404.9" y="294.2" width="12.9" height="23.8"/>
      <path class="cls-14" d="M412.4,242.9c0,.5-.4,1-1,1s-1-.4-1-1v-10.9c0-.5.4-1,1-1s1,.4,1,1v10.9Z"/>
      <g>
        <text v-if="lang === 'fr'" class="cls-154" transform="translate(397.8 288.1)"><tspan x="0" y="0">ÉCOLE</tspan></text>
        <text v-else class="cls-154" transform="translate(394.8 288.1)"><tspan x="0" y="0">SCHOOL</tspan></text>
      </g>
      <!-- <path class="cls-45" d="M424,288.1h0v-5.5s0-.1.1-.1h.7s.1,0,.1.1h0v4.7h2.6s.1,0,.1.1h0v.6s0,.1-.1.1h-3.4s-.1,0-.1-.1h0ZM395.3,286.2h.8v.3h0c0,.1,0,.2.1.3h0l.2.2s.2.1.3.2h0c.1,0,.2,0,.4.1h1.1s.2,0,.2-.1l.2-.2h0v-.2h0v-.6h0s0-.1-.2-.1c0,0-.2,0-.3-.1,0,0-.2,0-.3-.1-.2,0-.4,0-.6-.2-.3,0-.5-.1-.6-.2-.2,0-.3-.1-.4-.2-.1,0-.3-.2-.4-.2s-.2-.2-.3-.3h0c0-.1-.1-.2-.2-.4v-.8c0-.1.1-.3.2-.4h0c0-.1.2-.2.3-.3.1,0,.3-.2.4-.2h0c.2,0,.3-.1.5-.1h1.1c.2,0,.4,0,.5.2h0c.2,0,.3.2.4.3.1.1.2.2.3.4h0c0,.1.2.3.2.4v.5s0,.1-.1.1h-.7s-.1,0-.1-.1h0c0-.2,0-.3-.1-.4,0-.1-.1-.2-.2-.3h0s-.2-.1-.4-.2h-.5c-.4,0-.7,0-.9.2,0,0-.2.1-.2.2v.5s0,.1.1.2c0,0,.2.1.3.2.2,0,.4.1.7.2.3,0,.5.1.7.2.2,0,.4.1.5.2h0c.2,0,.3.2.4.3h0l.3.3h0c0,.1.1.3.2.4v.9c0,.1-.1.3-.2.4,0,.1-.2.3-.3.4-.1.1-.3.2-.4.3-.2,0-.3.1-.5.2h-1.3c-.2,0-.4,0-.6-.2-.2,0-.3-.2-.5-.3l-.4-.4h0c0-.2-.2-.3-.2-.5v-.6s0-.1.1-.1h0l.4-.3ZM404.7,286.1l.7.2s.1,0,0,.1h0c0,.3-.2.6-.3.8h0c-.1.2-.3.4-.5.6s-.4.3-.7.4h0c-.3,0-.5.1-.8.1h-.8c-.3,0-.5-.2-.7-.3-.2-.1-.4-.3-.5-.5s-.3-.4-.4-.6c0-.2-.2-.5-.2-.7v-1.6c0-.3.1-.5.3-.7.1-.2.3-.4.4-.6.2-.2.4-.3.6-.4s.4-.2.7-.3h.7c.2,0,.5,0,.8.1.2,0,.5.2.7.3h0c.2.1.4.3.5.5s.2.4.3.7v.2h0l-.7.2h-.1c0-.2-.1-.3-.2-.5,0-.1-.2-.2-.3-.3h0c-.1,0-.2-.1-.4-.2h-1c-.2,0-.3.1-.4.2-.1,0-.2.2-.3.3,0,.1-.2.3-.2.4,0,.2,0,.3-.1.5v1.1h0c0,.2,0,.4.1.5,0,.2.1.3.2.4,0,.1.2.2.3.3.1,0,.3.1.4.2h.9c.2,0,.3-.1.4-.2h0c.1-.1.2-.2.3-.4,0-.2.2-.4.2-.6,0,0,0-.1.1,0h0v-.2ZM406.3,288.1h0v-5.5s0-.1.1-.1h.7s.1,0,.1.1h0v2.1h2.6v-2.1s0-.1.1-.1h.7s.1,0,.1.1h0v5.5s0,.1-.1.1h-.7s-.1,0-.1-.1h0v-2.4h-2.6v2.4s0,.1-.1.1h-.7s-.1,0-.1-.1h0ZM411.7,285.5c0-.5,0-.9.2-1.3.1-.4.3-.7.6-1,.3-.3.5-.5.9-.6.3-.1.7-.2,1.1-.2h.8c.2,0,.5.2.7.3.2.1.4.3.6.5s.3.4.4.6.2.5.2.7v1.6c0,.3-.1.5-.3.7-.1.2-.3.4-.4.6h0c-.2.2-.4.3-.6.4s-.4.2-.7.3h-1.5c-.2,0-.5-.2-.7-.3-.2-.1-.4-.3-.6-.5s-.3-.4-.4-.6h0c-.1-.2-.2-.5-.2-.7v-.7h0v.2ZM412.7,285.5c0,.3,0,.6.1.8,0,.2.2.5.4.6.2.2.4.3.6.4.2,0,.4.1.7.1s.5,0,.7-.1c.2,0,.4-.2.6-.4.2-.2.3-.4.4-.6,0-.3.1-.6.1-.9v-.6c0-.2,0-.4-.2-.5,0-.2-.2-.3-.3-.4-.1-.1-.2-.2-.4-.3-.1,0-.3-.1-.4-.2h-.5c-.5,0-.9.2-1.2.5-.2.2-.3.4-.4.6,0,.3-.1.6-.1,1h-.1ZM417.8,285.5c0-.5,0-.9.2-1.3.1-.4.3-.7.6-1,.3-.3.5-.5.9-.6.3-.1.7-.2,1.1-.2h.8c.2,0,.5.2.7.3.2.1.4.3.6.5s.3.4.4.6.2.5.2.7v1.6c0,.3-.1.5-.3.7-.1.2-.3.4-.4.6h0c-.2.2-.4.3-.6.4s-.4.2-.7.3h-1.5c-.2,0-.5-.2-.7-.3-.2-.1-.4-.3-.6-.5s-.3-.4-.4-.6h0c-.1-.2-.2-.5-.2-.7v-.7h0v.2ZM418.7,285.5c0,.3,0,.6.1.8,0,.2.2.5.4.6.2.2.4.3.6.4s.4.1.7.1.5,0,.7-.1c.2,0,.4-.2.6-.4.2-.2.3-.4.4-.6,0-.3.1-.6.1-.9v-.6c0-.2,0-.4-.2-.5,0-.2-.2-.3-.3-.4-.1-.1-.2-.2-.4-.3-.1,0-.3-.1-.4-.2h-.5c-.5,0-.9.2-1.2.5-.2.2-.3.4-.4.6,0,.3-.1.6-.1,1h-.1Z"/> -->
      <path class="cls-45" d="M411.4,270.4c4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6-7.6,3.4-7.6,7.6,3.4,7.6,7.6,7.6Z"/>
      <path class="cls-7" d="M410.4,257.6c0-.5.4-1,1-1s1,.4,1,1v4.2h3.9c.5,0,1,.4,1,1s-.4,1-1,1h-4.9c-.5,0-1-.4-1-1v-5.2Z"/>
      <polygon class="cls-14" points="411.4 231 422.1 231 418.4 234.1 422.1 237.2 411.4 237.2 411.4 231"/>
      <polygon class="cls-7" points="391.6 270.4 336.7 270.4 342.6 256.6 397.5 256.6 391.6 262.5 391.6 270.4"/>
      <polygon class="cls-14" points="341.6 270.4 391.6 270.4 391.6 274.3 345.5 274.3 341.6 270.4"/>
      <polygon class="cls-5" points="436.4 270.4 431.3 265.3 431.3 270.4 436.4 270.4"/>
      <polygon class="cls-14" points="411.4 245.4 391.6 265 396.9 265 414.1 248.1 411.4 245.4"/>
      <path class="cls-30" d="M436.2,264.6c.8.8.8,2,0,2.8s-2,.8-2.8,0l-22-22-22,22c-.8.8-2,.8-2.8,0s-.8-2,0-2.8l23.4-23.4c.8-.8,2-.8,2.8,0l23.4,23.4Z"/>
      <polygon class="cls-5" points="404.9 294.2 417.9 294.2 417.9 318.1 404.9 294.2"/>
    </g>
    <g>
      <rect class="cls-33" x="370.9" y="332.7" width="8.8" height="11.1"/>
      <g>
        <polygon class="cls-31" points="376 351.8 378.1 351.8 377.9 362.9 376 362.8 376 358.1 376 351.8"/>
        <polygon class="cls-31" points="374.4 351.8 372.3 351.8 372.5 362.9 374.3 362.8 374.4 358.1 374.4 351.8"/>
      </g>
      <path class="cls-54" d="M372.4,362.4h2.1c.2.7.4,1.2.3,2h-4.3c0-1.1,1.6-1.6,1.9-2Z"/>
      <rect class="cls-3" x="370.4" y="364.1" width="4.4" height=".3"/>
      <path class="cls-54" d="M378,362.4h-2.1c-.2.7-.4,1.2-.3,2h4.3c0-1.1-1.6-1.6-1.9-2Z"/>
      <rect class="cls-3" x="375.5" y="364.1" width="4.4" height=".3"/>
      <path class="cls-9" d="M371.1,352h8.1v-8.8c0-1-.8-1.8-1.8-1.8h-4.5c-1,0-1.8.8-1.8,1.8v8.8h0Z"/>
      <path class="cls-31" d="M371.3,344.9s-.7,5.5-1.1,8.1h-.6l-.9-.8c.4-2.8,1-7.5,1-7.5l1.6.2h0Z"/>
      <path class="cls-9" d="M369.4,345.1l2,.4.8-4.1c-1.5-.3-2.2,1.2-2.3,1.8l-.4,1.9h-.1Z"/>
      <path class="cls-31" d="M370,354.2l-.4-1c0-.2,0-.4.2-.4h0c.2,0,.4,0,.4.2l.4,1c0,.2,0,.4-.2.4h0c-.2,0-.4,0-.4-.2Z"/>
      <path class="cls-31" d="M369.1,353.1v2.1c0,.2.2.3.4.3h0c.2,0,.3-.2.3-.4v-2.1c0-.2-.2-.3-.4-.3h0c-.2,0-.3.2-.3.4Z"/>
      <path class="cls-31" d="M368.7,352.6v2.1c0,.2.2.3.4.3h0c.2,0,.3-.2.3-.4v-2.1c0-.2-.2-.3-.4-.3h0c-.2,0-.3.2-.3.4Z"/>
      <path class="cls-31" d="M368.6,352.2v2.1c0,.2.2.3.4.3h0c.2,0,.3-.2.3-.4v-2.1c0-.2-.2-.3-.4-.3h0c-.2,0-.3.2-.3.4Z"/>
      <path class="cls-45" d="M378.2,341.4h0v.2c0,.7-.4,1.4-.9,1.8-.6.4-1.3.7-2.1.7s-1.6-.3-2.1-.7c-.6-.5-.9-1.1-.9-1.8s0-.1,0-.2h0c.4-.1.8-.2,1.2-.2h.9v.4h-1.3c0,.5.2.9.6,1.2.4.3,1,.5,1.6.5s1.2-.2,1.6-.5.6-.7.6-1.2h-1.3v-.4h.9c.4,0,.8,0,1.2.2h0Z"/>
      <path class="cls-31" d="M377.8,341.4v.3c0,1.2-1.2,2.2-2.7,2.2s-2.7-1-2.7-2.2,0-.2,0-.3h1.3v-1.5h0c0-.1,2.6-.1,2.6-.1h0v1.6h1.5Z"/>
      <path class="cls-27" d="M377.1,343.2l-3.2-3.2h0l.6-.2h0c0-.1,2-.1,2-.1h0v1.6h1.3v.3c0,.6-.3,1.1-.8,1.5h.1Z"/>
      <path class="cls-31" d="M375.2,329.8c-1.1,0-4.3.1-4.3,3.9s.7,5.1,1.2,5.7,1,1.1,2.1,1.3c.3.3.6.4,1,.4s.7-.2,1-.4c1-.3,1.6-.8,2.1-1.3.5-.6,1.3-1.9,1.2-5.7,0-3.7-3.3-3.8-4.3-3.9h0Z"/>
      <path class="cls-46" d="M375.2,329.8c1.1,0,4.3.1,4.3,3.9s-.7,5.1-1.2,5.7-1,1.1-2.1,1.3c-.3.3-.6.4-1,.4v-11.3h0Z"/>
      <path class="cls-31" d="M371.4,335.5c0-.2-.2-.4-.5-.5-.3,0-.9,0-.9,1s.7,1.6,1.2,1.5.2-1.8.2-2h0Z"/>
      <path class="cls-51" d="M377.5,331.9c.4.9.4,2.3,2.1,3.1,1.1-4.1-1.8-6-4.5-5.9-2.9,0-5,2-4.2,6,.9-1.3,6.1-2.7,6.6-3.2Z"/>
      <path class="cls-45" d="M376.6,338.2c-.1.7-.7,1.3-1.5,1.3s-1.4-.5-1.5-1.3h3Z"/>
      <path class="cls-2" d="M378.6,352h-6.9v4h6.9v-4Z"/>
      <path class="cls-51" d="M375.1,334.8c-1.4,0-2.9-.2-4.2-.6,0-.8,0-1.5.1-2.3.9-2.8,4-2.6,4-2.6,0,0,3.1-.2,4,2.6,0,.8,0,1.5.1,2.3-.3,0-.8.1-1.1.2-.2,0,0-.9-.6-2,.3,1.1.2,2.1,0,2.1-.7,0-1.7.2-2.4.2h.1Z"/>
      <g>
        <path class="cls-45" d="M374.2,346c-.3-.3-.6-.6-.9-.7-.2,0-.1,1.1,0,1.4,0,.4-.2.9.4,1.6.5.7,1.1,1,1.5.8.3.2.9-.1,1.5-.8.6-.8.4-1.3.4-1.6s.2-1.5,0-1.4c-.2,0-.6.4-.9.7-.7-.3-1.2-.3-1.9,0h-.1Z"/>
        <path class="cls-9" d="M374.8,348.3h0c0,.1-.1.1-.1.1,0,0-.2-.4-.7-.5h0q0-.1.1-.1c.7,0,.9.6.9.6h-.2Z"/>
        <path class="cls-9" d="M375.7,348.4h-.1c0-.1.2-.6.9-.7h.1c-.6.1-.7.6-.7.6h-.2Z"/>
        <path class="cls-9" d="M375.2,349.1s-.2-.2-.3-.2c0-.2.6-.2.5,0,0,0-.2.2-.3.2h0Z"/>
      </g>
      <path class="cls-35" d="M368.6,351.6l1.6.3c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3l-1.6-.3c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3Z"/>
      <path class="cls-46" d="M371.2,335.8c0-.1-.2-.3-.4-.3s-.5,0-.5.6.4,1,.7.9c0,0,.1-.1.2-.3-.2,0-.3-.2-.2-.5,0-.2.1-.3.2-.3h0Z"/>
      <g>
        <path class="cls-51" d="M377.2,335.7h0v-.2h0c0,.1.1.1.1.1q0-.1,0,0h-.1.1-.1c0,.2-.2.4-.4.4s-.4-.2-.4-.4.2-.4.4-.4l.4.5Z"/>
        <path class="cls-51" d="M377,335c-.1,0-.2,0-.2-.2s0-.2.2-.2c0,0,.3,0,.7.1,0,0,.1.1.1.2,0,0-.1.1-.2.1-.3-.1-.5,0-.5,0h-.1Z"/>
        <path class="cls-51" d="M373.1,335.7h0v-.2h0c0,.1-.1.1-.1.1q0-.1,0,0h.1-.1.1c0,.2.2.4.4.4s.4-.2.4-.4-.2-.4-.4-.4l-.4.5Z"/>
        <path class="cls-51" d="M373.4,334.6c.1,0,.2,0,.2.2s0,.2-.2.2h-.5s-.2,0-.2-.1c0,0,0-.2.1-.2.4-.1.7-.1.7-.1h-.1Z"/>
      </g>
      <path class="cls-51" d="M377.8,336.1h.2v-.2h0c-.3-.1-.8-.4-1.3.3v.2h.2c.4-.6.8-.4,1-.3h-.1Z"/>
      <path class="cls-51" d="M372.6,336.1h-.2v-.2h0c.3-.1.8-.4,1.3.3v.2h-.2c-.4-.6-.8-.4-1-.3h.1Z"/>
      <g>
        <path class="cls-48" d="M377,354v-4.8c0-.2.2-.5.4-.5l4.7-.8c.2,0,.4.1.4.4v4.8c0,.2-.2.5-.4.5l-4.7.8c-.2,0-.4-.1-.4-.3h0Z"/>
        <path class="cls-35" d="M377.5,353.5v-4.4c0-.2.2-.4.4-.5l4.8-.8c.2,0,.4.1.4.3v4.4c0,.2-.2.4-.4.5l-4.8.8c-.2,0-.4-.1-.4-.3Z"/>
      </g>
      <path class="cls-31" d="M379.1,344.9s.7,5.5,1.1,8.1h.6l.9-.8c-.4-2.8-1-7.5-1-7.5l-1.6.2h0Z"/>
      <path class="cls-9" d="M381,345.1l-2,.4-.8-4.1c1.5-.3,2.2,1.2,2.3,1.8l.4,1.9h.1Z"/>
      <path class="cls-51" d="M378.2,332.7h1.6l.7,11c0,.9-1.4,2-2.2,2h0v-13.1h-.1Z"/>
      <path class="cls-31" d="M380.2,353.7v.2h-.4c.1.3.5.3.6.3.3,0,.4-.1.5-.3h0c.2,0,.4,0,.4-.2v-.2c.2,0,.3-.1.3-.2l.2-.9c0-.2,0-.4-.2-.4h0c-.2,0-.4,0-.4.2v.2c-.2,0-.3.1-.3.2v.2h-.4c-.2-.2-.5-.1-.5-.1.2.5.2.6.2,1h0Z"/>
      <path class="cls-31" d="M379.2,352.8l.9-.6c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5l-.9.6c-.2.1-.4,0-.5,0h0c-.1-.2,0-.4,0-.5Z"/>
    </g>
    <g>
      <g>
        <rect class="cls-24" x="417.8" y="354.3" width="34.6" height="4.3"/>
        <rect class="cls-17" x="417.8" y="358.6" width="34.6" height="4.3"/>
        <rect class="cls-17" x="423.5" y="362.9" width="1.4" height="2.9"/>
        <rect class="cls-17" x="445.1" y="362.9" width="1.4" height="2.9"/>
        <rect class="cls-24" x="417.8" y="365.8" width="34.6" height="3.4"/>
        <rect class="cls-17" x="422.6" y="369.2" width="3.3" height="5.3"/>
        <rect class="cls-17" x="444.2" y="369.2" width="3.3" height="5.3"/>
        <rect class="cls-17" x="458.3" y="361.7" width="2.9" height="9.8"/>
        <rect class="cls-24" x="461.2" y="361.7" width="2.9" height="9.8"/>
        <rect class="cls-17" x="464.1" y="361.7" width="2.9" height="9.8"/>
        <rect class="cls-49" x="461.8" y="371.5" width="1.6" height="2.9"/>
      </g>
      <g>
        <path class="cls-51" d="M445.9,349.9c.9-1.1,2.9-1.6,4.3.4,1.9,2.7-1.5,5.9-1.4,7.2,0,1.1.7,1.7.7,1.7,0,0-2,.2-3.1-1.6-1.1-1.8,1-6.1,1-7s-.6-.5-1,0c-.3.5-.5-.7-.5-.7Z"/>
        <path class="cls-44" d="M445.8,352.2c1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z"/>
        <polygon class="cls-4" points="441.9 371.3 439.9 371.3 440.1 382.2 441.9 382.1 441.9 377.5 441.9 371.3"/>
        <polygon class="cls-4" points="443.5 371.3 445.5 371.3 445.4 382.2 443.6 382.1 443.5 377.5 443.5 371.3"/>
        <rect class="cls-18" x="439.1" y="371.7" width="7.2" height="3.4"/>
        <path class="cls-6" d="M446.7,372.5h-7.9v-9.6c0-1,.8-1.8,1.8-1.8h4.4c1,0,1.8.8,1.8,1.8v9.6h0Z"/>
        <path class="cls-45" d="M440.4,361.1l.3.3,1.6,2.3.4.6.4-.6,1.6-2.3.2-.3h-4.5Z"/>
        <polygon class="cls-4" points="444.4 358.9 441.1 358.9 441.1 361.1 442.7 363.5 444.4 361.1 444.4 358.9"/>
        <polygon class="cls-37" points="443.7 362 441.1 359.4 441.1 358.9 444.4 358.9 444.4 361.1 443.7 362"/>
        <g>
          <path class="cls-35" d="M445.5,381.7h-2c-.2.6-.4,1.2-.3,1.9h4.2c0-1.1-1.5-1.6-1.8-1.9h-.1Z"/>
          <rect class="cls-43" x="443" y="383.4" width="4.3" height=".3"/>
          <path class="cls-39" d="M446.4,382.4s.2,0,.2-.1c0,0,0-.2-.1-.2,0,0-.6-.2-1.5.8v.2h.2c.8-.8,1.2-.7,1.2-.7h0Z"/>
          <path class="cls-39" d="M446,382.1s.2,0,.2-.1c0,0,0-.2-.1-.2,0,0-.6-.2-1.5.8v.2h.2c.8-.8,1.2-.7,1.2-.7h0Z"/>
        </g>
        <g>
          <path class="cls-35" d="M440,381.7h2c.2.6.4,1.2.3,1.9h-4.2c0-1.1,1.5-1.6,1.8-1.9h.1Z"/>
          <rect class="cls-43" x="438.1" y="383.4" width="4.3" height=".3"/>
          <path class="cls-39" d="M439,382.4s-.2,0-.2-.1c0,0,0-.2.1-.2,0,0,.6-.2,1.5.8v.2h-.2c-.8-.8-1.2-.7-1.2-.7h0Z"/>
          <path class="cls-39" d="M439.5,382.1s-.2,0-.2-.1c0,0,0-.2.1-.2,0,0,.6-.2,1.5.8v.2h-.2c-.8-.8-1.2-.7-1.2-.7h0Z"/>
        </g>
        <path class="cls-4" d="M446.6,364.7s.7,5.1,1.1,7.7h0c0,.1-.4,1.1-.4,1.1,0,.2,0,.4.2.4h0c.2,0,.4,0,.4-.2v-.4c.1,0,0,1.3,0,1.3,0,.2.1.3.3.3h0c.2,0,.3-.1.3-.3v-.2h0c.2,0,.3-.1.3-.3v-.2s.2-.2.2-.3v-2.2c-.4-2.8-1-7-1-7.1l-1.6.2.2.2Z"/>
        <path class="cls-6" d="M448.4,364.9l-1.9.4-.7-4c1.5-.2,2.1,1.1,2.3,1.8l.4,1.8h0Z"/>
        <path class="cls-4" d="M442.9,349.7c1,0,4.2.1,4.3,3.8,0,3.7-.7,5-1.2,5.6s-1,1-2,1.3c-.3.3-.5.4-1,.4s-.7-.2-1-.4c-1-.3-1.5-.8-2-1.3-.5-.6-1.3-1.9-1.2-5.6,0-3.7,3.2-3.8,4.3-3.8h-.2Z"/>
        <path class="cls-20" d="M442.9,349.7c1,0,4.2.1,4.3,3.8,0,3.7-.7,5-1.2,5.6s-1,1-2,1.3c-.3.3-.5.4-1,.4v-11.1h0Z"/>
        <path class="cls-4" d="M439.2,355.3c0-.2-.2-.4-.5-.5-.3,0-.9,0-.9,1s.7,1.6,1.2,1.5.2-1.7.2-2h0Z"/>
        <path class="cls-20" d="M439,355.6c0-.1-.2-.3-.4-.3s-.5,0-.5.6.4,1,.6.9c0,0,.1-.1.2-.3-.2,0-.3-.2-.2-.5,0-.2.1-.3.2-.3h0Z"/>
        <path class="cls-20" d="M446.5,355.4c.1-.2.3-.4.6-.5.3,0,.9,0,.9,1s-.7,1.6-1.2,1.5-.3-2-.3-2Z"/>
        <path class="cls-37" d="M446.8,355.6c0-.1.2-.3.4-.3s.5,0,.5.6-.4,1-.6.9c0,0-.1-.1-.2-.3.2,0,.3-.2.2-.5,0-.2-.1-.3-.2-.3h0Z"/>
        <path class="cls-51" d="M445.2,351.8c.4.9.4,2.2,2,3.1,1.1-4-1.7-5.9-4.4-5.8-2.9,0-5.4,2-4.6,5.9,1.9-.4,2.9-1.4,3.8-2.4-.3.9-.9,1.4-.7,1.3,1.8-.4,2.5-.5,3.9-2.1h0Z"/>
        <path class="cls-45" d="M444.1,357.9c0,.4-.6.8-1.2.8s-1.1-.3-1.2-.8h2.5,0Z"/>
        <path class="cls-51" d="M444.7,354.6s-.2,0-.2-.2c0,0,0-.2.2-.2,0,0,.3,0,.7.1,0,0,.1.1.1.2,0,0-.1.1-.2.1-.3-.1-.5,0-.5,0h-.1Z"/>
        <path class="cls-51" d="M441.1,354.3s.2,0,.2.2,0,.2-.2.2h-.5s-.2,0-.2-.1c0,0,0-.2.1-.2.3-.1.7-.1.7-.1h-.1Z"/>
        <path class="cls-45" d="M445.1,363.5c.1-.3.3-.4.6-.4s.6.2.6.5c0,.5-.6,1-1.1,1.5-.6-.5-1.1-1-1.1-1.5s.3-.5.6-.5.4.1.6.4h-.2Z"/>
        <g>
          <rect class="cls-13" x="437.7" y="365.2" width="6.5" height="5.1" rx=".4" ry=".4" transform="translate(-59.9 648.5) rotate(-69.1)"/>
          <rect class="cls-12" x="437.5" y="365.4" width="6.5" height="4.7" rx=".4" ry=".4" transform="translate(-60 648.3) rotate(-69.1)"/>
        </g>
        <path class="cls-4" d="M443.3,369.2l-.9.3c-.2,0-.4.1-.6,0-.9.3-2.8.8-3.3.7-.9-.1-1.2-.5-1.5-1-.6-1.3-.3-3.3.2-4.7l1.7.4c-.2.7-.9,2.8-.4,3.4.4.5,2.2-.2,2.7-.4,0,0,0-.4.1-.5h0v-.8c0-.2,0-.3.2-.4h0c.2,0,.3.1.4.3v.6h.4l1.7-.8c.2,0,.4,0,.4.2h0c0,.2,0,.4-.2.4l-.5.2c.1,0,.2,0,.3.2h0c0,.2,0,.4-.2.4h-.2c0,.1.1.2.1.2h0c0,.2,0,.4-.2.4h-.2c.1.1.2.2.2.3h0c0,.2-.1.3-.3.4h0v.2Z"/>
        <rect class="cls-13" x="441.1" y="364.4" width=".5" height="1.8" transform="translate(-57.4 647.3) rotate(-69.1)"/>
        <path class="cls-6" d="M437,364.7l1.9.4.9-3.9c-1.4-.3-2.2,1-2.3,1.7l-.5,1.8Z"/>
        <g>
          <g>
            <path class="cls-51" d="M445.4,355.6h.2v-.2h0c-.2-.2-.7-.5-1.3,0v.2h.2c.5-.4.8-.2,1,0h-.1Z"/>
            <path class="cls-51" d="M444.9,355.9c.2,0,.3-.2.3-.3s-.2-.3-.3-.3-.3.2-.3.3.2.3.3.3Z"/>
            <path class="cls-51" d="M445.5,355.1h0v.2q-.1,0,0,0h0v-.2Z"/>
            <path class="cls-51" d="M445.6,355.2h0l-.2.2h0l.2-.2Z"/>
          </g>
          <g>
            <path class="cls-51" d="M440.4,355.6h-.2v-.2h0c.2-.2.7-.5,1.3,0v.2h-.2c-.5-.4-.8-.2-1,0h.1Z"/>
            <path class="cls-51" d="M440.9,355.9c.2,0,.3-.2.3-.3s-.2-.3-.3-.3-.3.2-.3.3.2.3.3.3Z"/>
            <path class="cls-51" d="M440.3,355.1h0v.2q.1,0,0,0h0v-.2Z"/>
            <path class="cls-51" d="M440.2,355.2h0l.2.2h0l-.2-.2Z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <polygon class="cls-47" points="475.5 342.7 473.7 342.7 473.8 352.7 475.5 352.6 475.5 348.4 475.5 342.7"/>
      <polygon class="cls-47" points="477 342.7 478.8 342.7 478.7 352.7 477 352.6 477 348.4 477 342.7"/>
      <rect class="cls-40" x="472.9" y="343" width="6.7" height="3.2"/>
      <path class="cls-35" d="M479.9,343.7h-7.3v-8.9c0-.9.7-1.6,1.6-1.6h4.1c.9,0,1.6.7,1.6,1.6v8.9h0Z"/>
      <g>
        <path class="cls-11" d="M472.1,324c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2,2.2-1,2.2-2.2-1-2.2-2.2-2.2Z"/>
        <path class="cls-11" d="M480.3,324c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2,2.2-1,2.2-2.2-1-2.2-2.2-2.2Z"/>
      </g>
      <polygon class="cls-47" points="477.7 331.3 474.7 331.3 474.7 333.3 476.2 335.5 477.7 333.3 477.7 331.3"/>
      <polygon class="cls-1" points="477.1 334.2 474.7 331.8 474.7 331.3 477.7 331.3 477.7 333.3 477.1 334.2"/>
      <path class="cls-1" d="M476.2,322.6c-1,0-3.9.1-3.9,3.5s.7,4.6,1.1,5.2c.5.5.9,1,1.9,1.2.2.2.5.3.9.4.4,0,.7-.1.9-.4.9-.2,1.4-.7,1.9-1.2s1.2-1.8,1.1-5.2c0-3.4-3-3.5-3.9-3.5Z"/>
      <path class="cls-47" d="M476.2,322.6c-1,0-3.9.1-3.9,3.5s.7,4.6,1.1,5.2c.5.5.9,1,1.9,1.2.2.2.5.3.9.4v-10.3h0Z"/>
      <path class="cls-47" d="M472.9,327.8c-.1-.2-.3-.4-.5-.4-.3,0-.8,0-.8.9s.7,1.5,1.1,1.4c.4,0,.2-1.8.2-1.8h0Z"/>
      <path class="cls-1" d="M472.6,328.1c0-.1-.2-.2-.3-.3-.2,0-.4,0-.4.5s.3.9.6.8c0,0,.1-.1.1-.3-.2,0-.3-.2-.2-.4,0-.1.1-.3.2-.3h0Z"/>
      <path class="cls-11" d="M474.6,326.9s.2,0,.2-.2c0,0,0-.2-.2-.2,0,0-.3,0-.6.1,0,0-.1.1,0,.2,0,0,.1.1.2,0h.5-.1Z"/>
      <path class="cls-11" d="M477.9,326.5s-.2,0-.2.2c0,0,0,.2.2.2h.7v-.2c-.3-.1-.6-.1-.6-.1h-.1Z"/>
      <path class="cls-11" d="M474.1,324.5c-.4.8-.4,2-1.9,2.9-1-3.7,1.6-5.4,4.1-5.4s5,1.8,4.3,5.5c-1.8-.4-2.7-1.3-3.5-2.2.3.8.8,1.3.7,1.2-1.7-.4-2.3-.5-3.6-2h-.1Z"/>
      <g>
        <path class="cls-35" d="M478.7,352.2h-1.9c-.2.6-.4,1.1-.3,1.8h3.9c0-1-1.4-1.4-1.7-1.8Z"/>
        <rect class="cls-43" x="476.5" y="353.8" width="4" height=".2"/>
        <path class="cls-39" d="M479.6,352.9s.1,0,.2-.1c0,0,0-.1-.1-.2,0,0-.6-.1-1.4.7v.2h.2c.7-.7,1.1-.6,1.1-.6h0Z"/>
        <path class="cls-39" d="M479.2,352.6s.1,0,.2-.1c0,0,0-.1-.1-.2,0,0-.6-.1-1.4.7v.2h.2c.7-.7,1.1-.6,1.1-.6h0Z"/>
      </g>
      <g>
        <path class="cls-35" d="M473.7,352.2h1.9c.2.6.4,1.1.3,1.8h-3.9c0-1,1.4-1.4,1.7-1.8Z"/>
        <rect class="cls-43" x="471.9" y="353.8" width="4" height=".2"/>
        <path class="cls-39" d="M472.8,352.9s-.1,0-.2-.1c0,0,0-.1.1-.2,0,0,.6-.1,1.4.7v.2h-.2c-.7-.7-1.1-.6-1.1-.6h0Z"/>
        <path class="cls-39" d="M473.2,352.6s-.1,0-.2-.1c0,0,0-.1.1-.2,0,0,.6-.1,1.4.7v.2h-.2c-.7-.7-1.1-.6-1.1-.6h0Z"/>
      </g>
      <path class="cls-1" d="M479.6,327.8c0-.2.2-.4.5-.4s.8,0,.8.9-.7,1.5-1.1,1.4c-.4,0-.2-1.6-.2-1.8h0Z"/>
      <path class="cls-23" d="M479.8,328.1c0-.1.2-.2.3-.3.2,0,.4,0,.4.5s-.3.9-.6.8c0,0-.1-.1-.1-.3.2,0,.3-.2.2-.4,0-.1-.1-.3-.2-.3h0Z"/>
      <path class="cls-45" d="M477,330.1c0,.4-.4.8-.8.8s-.8-.4-.8-.8h1.6,0Z"/>
      <rect class="cls-42" x="473.7" y="351.1" width="1.8" height="1.1"/>
      <rect class="cls-42" x="476.9" y="351.1" width="1.8" height="1.1"/>
      <polygon class="cls-26" points="476.2 335.5 477.9 335 477.9 333.3 477.7 333.3 476.2 335.5"/>
      <polygon class="cls-26" points="476.2 335.5 474.6 335 474.6 333.3 474.7 333.3 476.2 335.5"/>
      <g>
        <g>
          <path class="cls-51" d="M478.6,328.1h.1c-.2-.3-.6-.6-1.2-.1h0c0,.1.1.1.1.1.5-.4.8-.2,1,0h0Z"/>
          <path class="cls-51" d="M478.1,327.8c-.2,0-.3.1-.3.3s.1.3.3.3.3-.1.3-.3-.1-.3-.3-.3Z"/>
          <path class="cls-51" d="M478.6,327.8h0v.2q-.1,0,0,0h0v-.2Z"/>
          <path class="cls-51" d="M478.8,327.8h0l-.2.2h0l.2-.2Z"/>
        </g>
        <g>
          <path class="cls-51" d="M473.9,328.1h-.1c.2-.3.6-.6,1.2-.1h0c0,.1-.1.1-.2.1-.5-.4-.8-.2-1,0h.1Z"/>
          <path class="cls-51" d="M474.4,327.8c.2,0,.3.1.3.3s-.1.3-.3.3-.3-.1-.3-.3.1-.3.3-.3Z"/>
          <path class="cls-51" d="M473.8,327.8h0v.2q.1,0,0,0h0v-.2Z"/>
          <path class="cls-51" d="M473.7,327.8h0l.2.2h0l-.2-.2Z"/>
        </g>
      </g>
      <g>
        <path class="cls-47" d="M472.5,336.6s-.7,4.9-1,7.3h-.5l-.8-.7c.4-2.5.9-6.7.9-6.8l1.5.2h-.1Z"/>
        <path class="cls-35" d="M470.8,336.8l1.8.3.7-3.7c-1.3-.2-2,1-2.1,1.6l-.4,1.7h0Z"/>
        <path class="cls-47" d="M471.3,344.9l-.3-.9c0-.2,0-.3.2-.4h0c.2,0,.3,0,.4.2l.3.9c0,.2,0,.3-.2.4h0c-.2,0-.3,0-.4-.2Z"/>
        <path class="cls-47" d="M470.6,343.9v1.9c0,.2.2.3.4.3h0c.2,0,.3-.1.3-.3v-1.9c0-.2-.2-.3-.4-.3h0c-.2,0-.3.1-.3.3Z"/>
        <path class="cls-47" d="M470.2,343.5v1.9c0,.2.2.3.4.3h0c.2,0,.3-.1.3-.3v-1.9c0-.2-.2-.3-.4-.3h0c-.2,0-.3.1-.3.3Z"/>
        <path class="cls-47" d="M470.1,343.1v1.9c0,.2.2.3.4.3h0c.2,0,.3-.1.3-.3v-1.9c0-.2-.2-.3-.4-.3h0c-.2,0-.3.1-.3.3Z"/>
      </g>
      <rect class="cls-53" x="470.9" y="335.9" width=".6" height="1.8" transform="translate(45.9 729.9) rotate(-78.3)"/>
      <path class="cls-47" d="M483,336.6l.7.3c.2,0,.3,0,.6-.3.2-.2.4-.1.8-.2.2,0,.4-.2.5-.3.1,0,.2-.2.2-.3.1,0,.2-.2.1-.3h0s0-.1-.1-.2v-.2h0c0-.1-.2-.2-.3-.1h-.3c-.3.1-.6.2-.8.3v-.2h-.4l-.3.3c-.2,0-.3,0-.4.2-.2.3-.3,1-.2,1h-.1Z"/>
      <path class="cls-47" d="M481.2,336.3c.1.6.5,2.2.5,2.2,0,0,.4-.8,1.3-2.4l.9.8c-1.4,3.1-2.1,3.4-2.9,3-.3-.3-.5-1-.8-1.8-.1-.4-.3-.8-.4-1.1l1.4-.7Z"/>
      <path class="cls-35" d="M481.4,336.8l-1.8.3-.7-3.7c1.3-.2,2,1,2.1,1.6l.4,1.7h0Z"/>
      <rect class="cls-53" x="479.6" y="337.2" width="1.8" height=".6" transform="translate(-58.5 104.4) rotate(-11.7)"/>
      <path class="cls-16" d="M484.8,332.8c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5,1.5-.7,1.5-1.5-.7-1.5-1.5-1.5Z"/>
      <path class="cls-38" d="M484,332.7c0-.3-.1-.5-.3-.7-.2-.2-.5-.2-.8-.1,0,.3.1.5.3.7.2.2.5.2.8.1Z"/>
      <path class="cls-34" d="M484.2,333.3h0s-.1-.4,0-1.3h0c-.2.8,0,1.2,0,1.2h0Z"/>
    </g>
    <g>
      <path class="cls-2" d="M394,344.3h5.6c1.3,0,2.3,1,2.3,2.3v7.3c0,1.3-1,2.3-2.3,2.3h-5.6c-1.3,0-2.3-1-2.3-2.3v-7.3c0-1.3,1-2.3,2.3-2.3Z"/>
      <path class="cls-10" d="M393,357.1h7.6v-9.4c0-.9-.8-1.7-1.7-1.7h-4.2c-.9,0-1.7.8-1.7,1.7v9.4h0Z"/>
      <path class="cls-28" d="M393.2,365.8h3c.3.7.2,1.5.2,2.2h-5.2c0-1.2,2-1.5,2-2.2Z"/>
      <path class="cls-27" d="M392.8,366.5c-.1,0-.2,0-.2-.2s0-.2.2-.2c0,0,.4,0,.7.5v.3h-.3c-.2-.3-.4-.3-.4-.3h0Z"/>
      <rect class="cls-15" x="391.1" y="367.6" width="5.4" height=".4"/>
      <path class="cls-27" d="M392.2,366.9c-.1,0-.2,0-.2-.2s0-.2.2-.2c0,0,.4,0,.7.5v.3h-.3c-.2-.3-.4-.3-.4-.3h0Z"/>
      <path class="cls-28" d="M400.4,365.8h-3c-.3.7-.2,1.5-.2,2.2h5.2c0-1.2-2-1.5-2-2.2Z"/>
      <path class="cls-27" d="M400.8,366.1c.1,0,.2,0,.2.2s0,.2-.2.2c0,0-.2,0-.4.3,0,0-.2.1-.3,0,0,0-.1-.2,0-.3.4-.5.7-.5.7-.5h0Z"/>
      <rect class="cls-15" x="397.2" y="367.6" width="5.4" height=".4"/>
      <path class="cls-27" d="M401.4,366.5c.1,0,.2,0,.2.2s0,.2-.2.2c0,0-.2,0-.4.3,0,0-.2.1-.3,0,0,0-.1-.2,0-.3.4-.5.7-.5.7-.5h0Z"/>
      <path class="cls-21" d="M400.6,356.1h-7.6v9.8h3.4l-.3-8.4h1.3l-.3,8.4h3.4v-9.8h.1Z"/>
      <polygon class="cls-2" points="394.2 356.1 394.7 356.5 393.3 358.2 392.9 357.8 394.2 356.1"/>
      <polygon class="cls-2" points="399.4 356.1 398.9 356.5 400.3 358.2 400.7 357.8 399.4 356.1"/>
      <path class="cls-45" d="M398.9,346h0v.2c-.1.5-.4.9-.8,1.1-.4.3-.8.4-1.3.4s-.9-.2-1.3-.4c-.4-.3-.6-.7-.8-1.1h0v-.2h1c0,.2.2.4.4.5.2.1.4.2.7.2s.5,0,.7-.2c.2-.1.3-.3.4-.5h1,0Z"/>
      <path class="cls-31" d="M395.3,345.1h3.1v1c-.2.7-.8,1.2-1.6,1.2s-1.4-.5-1.6-1.2v-.9h0c0-.1.1-.1.1-.1Z"/>
      <path class="cls-27" d="M395.3,345.3l3-.2h0v1c-.2.6-.6,1-1.2,1.2l-1.9-1.9h.1Z"/>
      <g>
        <path class="cls-31" d="M396.8,335.2c-1,0-4.1.1-4.1,3.7s.7,4.9,1.2,5.5c.5.5,1,1,2,1.3.3.3.5.4,1,.4v-10.9h-.1Z"/>
        <path class="cls-46" d="M396.8,335.2c1,0,4.1.1,4.1,3.7s-.7,4.9-1.2,5.5c-.5.5-1,1-2,1.3-.3.3-.5.4-1,.4v-10.9h.1Z"/>
      </g>
      <path class="cls-29" d="M399.5,336.9c-.2-.3-.4-.6-1.4-.2s-2.5,1.3-4.4,1.2c-.6,1.1-.4,3.3-.4,3.3l-1-.7s-.2-2.4.2-3.2c-.3,0-.6-.4-.5-1.1.4,0,.6.4,1.1,0s1.6-1.8,3.7-1.8,2.9,1.2,3.2,1.6c1.4,1.2,1.3,2.7,1.2,4.5l-1,.7c0-.7-.1-3.4-.6-4.2h-.1Z"/>
      <path class="cls-31" d="M393.2,340.8c0-.2-.2-.4-.5-.5-.3,0-.8,0-.8.9s.7,1.6,1.1,1.5.2-1.7.2-1.9h0Z"/>
      <path class="cls-46" d="M393,341c0-.1-.2-.3-.3-.3-.2,0-.4,0-.4.6s.4,1,.6.9c0,0,.1-.1.2-.3-.2,0-.3-.2-.2-.4,0-.2.1-.3.2-.3h0v-.2Z"/>
      <path class="cls-46" d="M400.3,340.8c.1-.2.3-.4.6-.5.3,0,.8,0,.8.9s-.7,1.6-1.1,1.5-.3-1.9-.3-1.9Z"/>
      <path class="cls-27" d="M400.6,341c0-.1.2-.3.3-.3.2,0,.4,0,.4.6s-.4,1-.6.9c0,0-.1-.1-.2-.3.2,0,.3-.2.2-.4,0-.2-.1-.3-.2-.3h0v-.2Z"/>
      <path class="cls-29" d="M394.4,339.8h1c.1,0,.2,0,.2-.2h0c0-.1,0-.2-.2-.2h-1c-.1,0-.2.1-.2.2h0c0,.1,0,.2.2.2Z"/>
      <path class="cls-29" d="M398.2,339.8h1c.1,0,.2,0,.2-.2h0c0-.1,0-.2-.2-.2h-1c-.1,0-.2.1-.2.2h0c0,.1,0,.2.2.2Z"/>
      <path class="cls-45" d="M397.6,342.9c0,.5-.4.9-.8.9s-.8-.4-.8-.9h1.7-.1Z"/>
      <path class="cls-10" d="M403,349.2l-1.8.8-1.7-3.7c1.3-.6,2.3.6,2.6,1.2l.9,1.7Z"/>
      <path class="cls-2" d="M400.1,346.1s-.6,3.8-.4,5.5c-.2.2-.8.6-1.5,0-.2-1.9.4-5.6.4-5.7h1.5v.2Z"/>
      <path class="cls-31" d="M398.1,352.8l.7.5c.2.2.5.3.7.1l.7-.7c.2-.2.1-.4.1-.7v-.2h0v-1c0-.2-.2-.3-.3-.3h0c-.2,0-.3.2-.3.3v.5h-.1l-1.3-1c-.1-.1-.3,0-.4,0h0c-.1.1,0,.3,0,.4l.4.3c-.1,0-.2,0-.3.1h0c-.1.1,0,.3,0,.4h.2c0,.1-.1.2-.1.2h0c-.1.1,0,.3,0,.4h.1c-.1,0-.2.2-.3.3h0c0,.2,0,.3.2.4h0Z"/>
      <path class="cls-31" d="M402.9,349.3c1.2,2.7,1.1,4,.2,4.7-.3.2-.9.6-1.6.6s-1.2-.4-2.1-1.1l.9-1.2c.7.5,1.1.7,1.3.7,1.3-.4,0-2.7-.2-3l1.5-.7h0Z"/>
      <path class="cls-10" d="M390.5,349.2l1.8.8,1.7-3.7c-1.3-.6-2.3.6-2.6,1.2l-.9,1.7Z"/>
      <path class="cls-2" d="M393.3,346.1s.6,3.8.4,5.5c.2.2.8.6,1.5,0,.2-1.9-.4-5.6-.4-5.7h-1.5v.2Z"/>
      <path class="cls-31" d="M395.4,352.8l-.7.5c-.2.2-.5.3-.7.1l-.7-.7c-.2-.2-.1-.4-.1-.7v-.2h0v-1c0-.2.2-.3.3-.3h0c.2,0,.3.2.3.3v.5h.1l1.3-1c.1-.1.3,0,.4,0h0c.1.1,0,.3,0,.4l-.4.3c.1,0,.2,0,.3.1h0c.1.1,0,.3,0,.4h-.2c0,.1.1.2.1.2h0c.1.1,0,.3,0,.4h-.1c.1,0,.2.2.3.3h0c0,.2,0,.3-.2.4h0Z"/>
      <path class="cls-31" d="M390.6,349.3c-1.2,2.7-1.1,4-.2,4.7.3.2.9.6,1.6.6s1.2-.4,2.1-1.1l-.9-1.2c-.7.5-1.1.7-1.3.7-1.3-.4,0-2.7.2-3l-1.5-.7h0Z"/>
      <g>
        <path class="cls-28" d="M398.9,340.5c-.2,0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4Z"/>
        <path class="cls-28" d="M399.4,340.8h.2v-.2h0c-.3-.2-.7-.5-1.3,0v.2h.2c.5-.4.8-.2,1,0h-.1Z"/>
        <path class="cls-28" d="M394.7,340.5c.2,0,.4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4Z"/>
        <path class="cls-28" d="M394.2,340.8h-.2v-.2h0c.3-.2.7-.5,1.3,0v.2h-.2c-.5-.4-.8-.2-1,0h.1Z"/>
      </g>
    </g>
  </g>
</svg>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    manualHighlight: Boolean,
    lang:String
  },
  data() {
    return {
      highlight: false,
      found: false
    }
  },
  methods:{
      clickHome: function(){
        this.found = true
        this.$parent.showModal('School')
      },
      showHighlight: function(){
        this.highlight = true
      },
      hideHighlight: function(){
        this.highlight = false
      }
    }
}
</script>

<style scoped>
.cls-1 {
        fill: #9e5a29;
      }

      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54 {
        stroke-width: 0px;
      }

      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9, .cls-10, .cls-11, .cls-14, .cls-16, .cls-20, .cls-21, .cls-22, .cls-23, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-51, .cls-54 {
        fill-rule: evenodd;
      }

      .cls-2, .cls-12 {
        fill: #366;
      }

      .cls-3 {
        fill: #333;
      }

      .cls-4 {
        fill: #a44624;
      }

      .cls-5 {
        fill: #629c8a;
      }

      .cls-6 {
        fill: #f69883;
      }

      .cls-7, .cls-41 {
        fill: #7bc3ad;
      }

      .cls-8, .cls-22 {
        fill: #f77917;
      }

      .cls-9 {
        fill: #fcc;
      }

      .cls-10 {
        fill: #9cc;
      }

      .cls-11 {
        fill: #1f0f05;
      }

      .cls-13, .cls-48 {
        fill: #ffc;
      }

      .cls-14 {
        fill: #eb6600;
      }

      .cls-15, .cls-27 {
        fill: #d4a15e;
      }

      .cls-16 {
        fill: #ff441f;
      }

      .cls-17 {
        fill: #be574d;
      }

      .cls-18, .cls-35 {
        fill: #f1502d;
      }

      .cls-19 {
        /*  */
        fill: #fff;
      }

      .cls-20 {
        fill: #78331a;
      }

      .cls-21 {
        fill: #699;
      }

      .cls-23 {
        fill: #804921;
      }

      .cls-24 {
        fill: #f27350;
      }

      .cls-25 {
        fill: #69990a;
      }

      .cls-26, .cls-53 {
        fill: #ff6;
      }

      .cls-28, .cls-43 {
        fill: #471e04;
      }

      .cls-29 {
        fill: #bf3611;
      }

      .cls-30 {
        fill: #f6aa32;
      }

      .cls-31 {
        fill: #f2d291;
      }

      .cls-32, .cls-52 {
        fill: #e6e6e6;
      }

      .cls-33, .cls-51 {
        fill: #000;
      }

      .cls-34 {
        fill: #500d00;
      }

      .cls-36 {
        fill: #de6105;
      }

      .cls-37 {
        fill: #4e2111;
      }

      .cls-38 {
        fill: #88b02c;
      }

      .cls-39, .cls-42 {
        fill: #f7c5a3;
      }

      .cls-40 {
        fill: #900;
      }

      .cls-44 {
        fill: #f5b800;
      }

      .cls-45, .cls-50 {
        fill: #fff;
      }

      .cls-46 {
        fill: #edba68;
      }

      .cls-47 {
        fill: #d48439;
      }

      .cls-49 {
        fill: #83694e;
      }

      .cls-54 {
        fill: #3b696a;
      }

      .cls-154 {
        font-family: Arial-BoldMT, Arial;
        font-size: 7.7px;
        font-weight: 700;
        fill: #fff;
        isolation: isolate;
      }
</style>
